import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem('token')) fetchMe();
    else setLoading(false);
  }, [fetchMe]);

  // Heartbeat every 60s to track attendance
  useEffect(() => {
    if (!user) return;
    const interval = setInterval(() => {
      api.post('/attendance/heartbeat').catch(() => {});
    }, 60000);
    return () => clearInterval(interval);
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch (e) {}
    localStorage.removeItem('token');
    setUser(null);
  };

  const updateStatus = async (status) => {
    const { data } = await api.put('/auth/status', { status });
    setUser(data);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateStatus, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
